var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFistFormUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 98,
    viewBox: "0 0 225 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_1461)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 30,
    width: 87,
    height: 32,
    rx: 4,
    fill: "#E86E4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 67.5,
    width: 86,
    height: 23,
    rx: 3.5,
    stroke: "#E4E5E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 94.5,
    width: 86,
    height: 23,
    rx: 3.5,
    stroke: "#E4E5E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 22.5,
    width: 102,
    height: 106,
    rx: 7.5,
    stroke: "#E4E5E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_1461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 98,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFistFormUser);
export default __webpack_public_path__ + "static/media/fist-form-user.c4b851be46b7a698284e279889920336.svg";
export { ForwardRef as ReactComponent };